import React, {PureComponent} from 'react';
import {FastField, FieldArray, ErrorMessage} from 'formik';
import {FormattedMessage} from 'react-intl';
import {get, pick} from 'lodash';
import classNames from 'classnames';
import messages from '../../../../../res/translations/messages';
import FormRow from '../FormRow';
import ShuffledRowLimitChoiceType from '../ShuffledRowLimitChoiceType';
import ShuffledOccurrenciesExclusiveChoiceType from '../ShuffledOccurrenciesExclusiveChoiceType';
import CommonFields from './CommonFields';
import Error from '../../../Error';
import InvertBatteryButton from '../InvertBatteryButton';

class Battery2Type extends PureComponent {
    constructor(props) {
        super(props);
        this.onInvert = this.onInvert.bind(this);
        this.onMinUpdate = this.onMinUpdate.bind(this);
        this.onMaxUpdate = this.onMaxUpdate.bind(this);
    }

    onMinUpdate(e) {
        const {name, form} = this.props;
        const intVal = parseInt(e.currentTarget.value) || 0;
        // this is needed or the value won't be updated to the field
        form.setFieldValue(`${name}.min`, intVal > 0 ? intVal : '');
    }

    onMaxUpdate(e) {
        const {name, form} = this.props;
        const intVal = parseInt(e.currentTarget.value) || 0;
        // this is needed or the value won't be updated to the field
        form.setFieldValue(`${name}.max`, intVal > 0 ? intVal : '');
    }

    onInvert() {
        const {name, form} = this.props;
        const values = get(form.values, name);
        const {choices, rows} = values;
        form.setFieldValue(`${name}.rows`, choices.map((choice) =>
            Object.assign({shuffle: false, min: '', max: ''}, pick(choice, ['id', 'value']))), false);
        form.setFieldValue(`${name}.choices`, rows.map((row) =>
            Object.assign({shuffle: false, exclusive: false, occurrencies: ''}, pick(row, ['id', 'value']))));
    }

    render() {
        const {name, form, previousPages} = this.props;

        return (
            <>
                <CommonFields name={name} form={form} required={true} previousPages={previousPages} />
                <FormRow name={`${name}.min`} label={messages.surveys.form.label.min} size={3}>
                    <FastField id={`${name}.min`} name={`${name}.min`} type="number" step="any" onChange={this.onMinUpdate}
                        className={classNames('form-control',
                            {error: get(form.errors, `${name}.min`) && get(form.touched, `${name}.min`)})} />
                    <ErrorMessage name={`${name}.min`}>{(message) => <Error reason={message.key} reasonParams={message.params} />}</ErrorMessage>
                </FormRow>
                <FormRow name={`${name}.max`} label={messages.surveys.form.label.max} size={3}>
                    <FastField id={`${name}.max`} name={`${name}.max`} type="number" step="any" onChange={this.onMaxUpdate}
                        className={classNames('form-control',
                            {error: get(form.errors, `${name}.max`) && get(form.touched, `${name}.max`)})} />
                    <ErrorMessage name={`${name}.max`}>{(message) => <Error reason={message.key} reasonParams={message.params} />}</ErrorMessage>
                </FormRow>
                <div className="form-group">
                    <div className="row">
                        <div className="col">
                            <h4 htmlFor={`${name}.choices`}>&gt; <FormattedMessage {...messages.surveys.form.label.optionList} /></h4>
                        </div>
                        <div className="col-auto">
                            <InvertBatteryButton onClick={this.onInvert} />
                        </div>
                    </div>
                    <FieldArray name={`${name}.choices`} component={ShuffledOccurrenciesExclusiveChoiceType} />
                    <ErrorMessage name={`${name}.choices`}>{(message) => <Error reason={message.key} reasonParams={message.params} />}</ErrorMessage>
                </div>
                <div className="form-group">
                    <div className="row">
                        <div className="col">
                            <h4 htmlFor={`${name}.rows`}>&gt; <FormattedMessage {...messages.surveys.form.label.rows} /></h4>
                        </div>
                        <div className="col-auto">
                            <InvertBatteryButton onClick={this.onInvert} />
                        </div>
                    </div>
                    <FieldArray name={`${name}.rows`} component={ShuffledRowLimitChoiceType} previousPages={previousPages} />
                    <ErrorMessage name={`${name}.rows`}>{(message) => <Error reason={message.key} reasonParams={message.params} />}</ErrorMessage>
                </div>
            </>
        );
    }
}

export default Battery2Type;
